import { camelCaseKeysDeep } from '@zapier/common-utils';
import { useEffect, useState } from 'react';

const useSupportEligibility = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [eligibility, setEligibility] = useState({
    isEmailSupportEligible: undefined,
    isPremierSupportEligible: undefined,
    isPaidEmailSupportEligible: undefined,
    isCriticalTicketEligible: undefined,
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEligibilityData = async () => {
      const eligibilityUrl = `${
        process.env.ZAPIER_API_BASE_URL || ''
      }/api/v4/support-eligibility/`;

      try {
        const response = await fetch(eligibilityUrl);

        if (response.ok) {
          const result = await response.json();
          setEligibility(camelCaseKeysDeep(result));
        } else {
          throw new Error(`Error: ${response.statusText}`);
        }
      } catch (err) {
        setError('An error occurred while fetching eligibility data.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchEligibilityData();
  }, []); // Empty dependency array to run only once

  return {
    isLoading,
    eligibility,
    error,
  };
};

export default useSupportEligibility;
